import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Card, makeStyles, Typography } from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import ImagineSlider from '../Shared/ImagineSlider';
import { ArticleCard } from './ArticleCard';
import { ArticleNextArrow, ArticlePrevArrow } from './ArticleSliderOptions';
import { useWindowSize } from '../../hooks';
import { history } from '../../helpers';
import config from '../../config';
import { EmptyState } from '../Shared/EmptyState';
import {contentsIcon} from '../../assets/imgs/emptystate';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderRadius: 8,
    border: `1px solid ${theme.palette.neutrals.high.medium}`,
    marginTop: theme.spacing(2),
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',

    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    }
  },
  cardTitle: {
    color: theme.palette.neutrals.low.main,
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  textSeeAll: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.neutrals.low.light,
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
  seeAllContainer: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.auxiliary.beige.main
  },
  cardEmpty: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(4, 0),
    borderRadius: 8,
    border: `1px solid ${theme.palette.neutrals.high.medium}`,
  }
}));

export function IdeaByCategoryList() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [width] = useWindowSize();
  const { ideasByCategories } = useSelector(state => state.timeline);

  return (
    <>
      {ideasByCategories.map(item => (
        <Box className={classes.box} key={item._id}>
          <Card className={classes.row} elevation={0} onClick={() => history.push('/articles')}>
            <Typography variant="subtitle2" className={classes.cardTitle}>
              {item.title}
            </Typography>

            <Box className={classes.seeAllContainer}>
              <Typography className={classes.textSeeAll}>{t('ver_todas')}</Typography>
              <KeyboardArrowDown />
            </Box>
          </Card>
          {width > config.RESPONSIVE_MOBILE ? (
            <>
              {item?.ideas?.length > 0 ? (
                <ImagineSlider
                  settings={{
                    dots: false,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    nextArrow: <ArticleNextArrow />,
                    prevArrow: <ArticlePrevArrow />
                  }}
                >
                  {item?.ideas?.map((item, index) => (
                    <ArticleCard
                      key={index}
                      idea={item}
                      image={item?.cardThumbnail?.url ?? ""}
                      link={`/idea/${item?._id}/general`}
                      index={index}
                    />
                  ))}
                </ImagineSlider>
              ) : (
                <Card elevation={0} className={classes.cardEmpty}>
                  <EmptyState
                    icon={contentsIcon}
                    description="Nenhuma categoria disponível no momento!"
                  />
                </Card>
              )}
            </>
          ) : (
            <>
              {item?.ideas?.length > 0 ? (
                item.ideas?.map((item, index) => (
                  <ArticleCard
                    key={index}
                    idea={item}
                    image={item?.cardThumbnail?.url ?? ""}
                    link={`/idea/${item?._id}/general`}
                    index={index}
                  />
                ))
              ) : (
                <Card elevation={0} className={classes.cardEmpty}>
                  <EmptyState
                    icon={contentsIcon}
                    description="Nenhuma categoria disponível no momento!"
                  />
                </Card>
              )}
            </>
          )}
        </Box>
      ))}
    </>
  );
}